<template>
  <Notification :item="item">
    <template #logo>
      <FontAwesomeIcon
        :icon="['fak', 'list']"
        :style="{ height: '16px', width: '16px', color: 'currentColor' }"
        class="text-info-accent"
      />
    </template>
    <template #message> New Note </template>
    <template #description>
      <div class="c-new-report-note-notification__description">
        {{ notificationDescription }}
      </div>
    </template>
    <template #action>
      <BittsButton
        v-if="!!report"
        text="View Note"
        variant="outline"
        size="x-small"
        @click="handleButtonAction"
      />
    </template>
    <template #icon>
      <FontAwesomeIcon
        :icon="['fak', 'mapping']"
        :style="{ height: '12px', width: '12px', color: 'currentColor' }"
        class="text-neutral-accent ml-4"
      />
    </template>
  </Notification>
</template>

<script setup lang="ts">
import { BittsButton } from '@crossbeam/bitts';

import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import Notification from '@/components/notifications/Notification.vue';

import { useNotificationsStore, useReportsStore } from '@/stores';
import { Notification as NotificationType } from '@/types/notifications';

const props = defineProps<{ item: NotificationType }>();

const emit = defineEmits<(e: 'action-clicked', action: string) => void>();

const router = useRouter();
const notificationsStore = useNotificationsStore();
const { reports } = storeToRefs(useReportsStore());

const notificationDescription = computed(() => {
  const { data } = props.item;
  const userName = data?.user_name ?? 'Someone';
  const reportName = data?.report_name ?? 'a List';
  const noteText = data?.note_text ?? '';
  const recordName = data?.record_name ?? 'a record';

  if (noteText) {
    return `${userName} added a Note to ${recordName} in ${reportName}: "${noteText}"`;
  }
  return `${userName} added a Note to ${recordName} in ${reportName}`;
});

const report = computed(() => {
  return reports.value.find(
    (report) => report.id === props.item.data?.report_id,
  );
});

async function handleButtonAction() {
  emit('action-clicked', 'View Note');
  await notificationsStore.markRead({ id: props.item.id, isRead: true });

  const reportId = props.item.data?.report_id;
  if (reportId) {
    await router.push({
      name: 'edit_report',
      params: { report_id: reportId },
      query: {
        record_id: props.item.data?.record_id,
        tab: 'notes',
        sort_by_notes: 'true',
      },
    });
  }
}
</script>

<style scoped lang="pcss">
.c-new-report-note-notification__description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding-right: 1rem;
}
</style>
